import { superAdminService, SuscripcionItem } from '../services/superAdminService';
import { useCrudResource } from './useCrudResource';

type CreateSuscripcionPayload = Parameters<typeof superAdminService.createSuscripcion>[0];
type UpdateSuscripcionPayload = Parameters<typeof superAdminService.updateSuscripcion>[1];

export const useSuscripciones = () => {
  const crud = useCrudResource<SuscripcionItem, CreateSuscripcionPayload, UpdateSuscripcionPayload>({
    queryKey: ['superSuscripciones'],
    fetchList: superAdminService.getSuscripciones,
    create: (payload) => superAdminService.createSuscripcion(payload),
    update: (id, payload) => superAdminService.updateSuscripcion(id, payload),
    remove: (id) => superAdminService.deleteSuscripcion(id),
  });

  const updateSuscripcion = (
    vars: { id: number; payload: UpdateSuscripcionPayload },
    options?: Parameters<typeof crud.update>[1]
  ) => crud.update({ id: vars.id, data: vars.payload }, options);

  return {
    suscripciones: crud.items,
    isLoading: crud.isLoading,
    isFetching: crud.isFetching,
    error: crud.error,
    refetch: crud.refetch,
    createSuscripcion: crud.create,
    updateSuscripcion,
    deleteSuscripcion: crud.remove,
    isCreating: crud.isCreating,
    isUpdating: crud.isUpdating,
    isDeleting: crud.isRemoving,
  };
};
